import React from "react";
import Form from "../../components/Form";

export default function Branch() {
    return <Form type={"branch"}/>;
}
